import { defineStore } from 'pinia';
import i18n from '@/i18n';

const t = (key, params) => i18n.global.t(key, params);
import axios from '@/services/axios';
import router from '@/router';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        expiresAt: null, // timestamp in ms
        refreshTimer: null,
        router: null,
    }),

    actions: {
        handleLoginSuccess(expiresAt) {
            this.expiresAt = new Date(expiresAt).getTime();
            this.setRefreshTimer();
            console.log("handleLoginSuccess", this.expiresAt);
        },

        handleRenewSuccess(expiresAt) {
            this.expiresAt = new Date(expiresAt).getTime();
            this.setRefreshTimer();
            console.log("handleRenewSuccess", this.expiresAt);
        },

        async refreshToken() {
            try {
                const response = await axios.get('/conf/renew');
                this.handleRenewSuccess(response.data.expiry);
            } catch (err) {
                console.error("refreshToken");
                this.clearAuthState();
                router.replace({name: 'logout', query: { reason: t('api.sessionExpired')}});
            }
        },

        setRefreshTimer() {
            if (this.refreshTimer) clearTimeout(this.refreshTimer);

            const delay = this.expiresAt - Date.now() - 2 * 60 * 1000;  // 2 min before expiration

            if (delay <= 0) {
                this.refreshToken();
                return;
            }

            this.refreshTimer = setTimeout(() => {
                this.refreshToken();
            }, delay);
        },

        clearAuthState() {
            this.expiresAt = null;
            if (this.refreshTimer) clearTimeout(this.refreshTimer);
            this.refreshTimer = null;
        },
    }
});